module.exports = __webpack_public_path__ + "img/CAN_RED.520d0d33.svg";